module.exports = __webpack_public_path__ + "img/illustration.0a9ec6ac.png";